import { Helmet } from 'react-helmet-async';
import DashboardLayout from '@/components/layout/DashboardLayout';
import DocumentVaultSection from '@/components/dashboard/DocumentVaultSection';

const DocumentsPage = () => {
  return (
    <>
      <Helmet>
        <title>My Documents | Virewire Property Services</title>
        <meta name="description" content="Manage your property documents and certificates with Virewire." />
      </Helmet>

      <DashboardLayout>
        <div className="w-full space-y-6">
          <div>
            <h1 className="text-3xl font-bold text-primary">My Documents</h1>
            <p className="text-muted-foreground mt-1">Manage and store your important property documents</p>
          </div>

          <DocumentVaultSection limit={50} />
        </div>
      </DashboardLayout>
    </>
  );
};

export default DocumentsPage;
